import React from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import css from './skill-quests-mastery.scss';
import ConnectedAllClasses from './all-classes/all-classes';
import ConnectedStudent from './student/student';
import ConnectedSubHeading from '../../components/sub-heading/sub-heading';
import ConnectedSingleClass from './single-class/single-class';
import ConnectedReportRoutes from '../report-routes/report-routes';
import EmptyState from '../../components/empty-state/empty-state';
import EMPTY_STATE_VARIANTS from '../../components/empty-state/empty-state-constants';

const SkillQuestsMastery = ({ location }) => {
    const routeComps = {
        allClasses: ConnectedAllClasses,
        singleClass: ConnectedSingleClass,
        student: ConnectedStudent
    };

    /**
     * Updated UI/UX requires change to the regular structure of application
     * We do not render children for student level report
     * We will use 'student' keyword in url to match
     */
    const shouldDisplayChildren = () =>
        location.pathname.indexOf('student') === -1;

    return (
        <div className={css.component}>
            <EmptyState variant={EMPTY_STATE_VARIANTS.NO_STUDENTS}>
                <ConnectedReportRoutes components={routeComps}>
                    {shouldDisplayChildren() && (
                        <div>
                            <ConnectedSubHeading />
                            <div className={css['report-container']} />
                        </div>
                    )}
                </ConnectedReportRoutes>
            </EmptyState>
        </div>
    );
};

SkillQuestsMastery.propTypes = {
    location: PropTypes.any
};

export default styleable(css)(SkillQuestsMastery);



// WEBPACK FOOTER //
// ./containers/skill-quests-mastery/skill-quests-mastery.js